<!--<div style="border: 1px solid red">AirportManage Component</div>-->
<app-nav-menu></app-nav-menu>
<!--<div><button (click)="SweetSuccess(sweet)">success</button></div>-->
<!--<div class="air_heading">
  <span class="air_h1">Airport Manage</span>
</div>-->
<div>
  <ng-template #sweet let-modal>

    <div class="modal-success">
      <img class="sucesspopup" src="assets/img/newsuccess.gif" />

      <h2 class="textpopupsuccess"> Airpot Data Saved!</h2>
      <button class="okButton" (click)="modal.dismiss()">Ok</button>
    </div>


  </ng-template>
</div>

<!--bad-->
<div>
  <ng-template #bad let-modal>

    <div class="modal-success">
      <img class="sucesspopup" src="assets/img/badicon.gif" />

      <h2 class="textpopupbad"> Not Saved!</h2>
      <h5 class="textsubheadpopup"> Please Try Again!</h5>
      <button class="okButton" (click)="modal.dismiss()">Ok</button>

    </div>


  </ng-template>
</div>




<div class="cms_card">

  <div class="row-card">


    <div class="cms_card-heading"></div>

    <div class="addnewbutton">
      <p class="headingpage">Airport List</p>
      <a class="card-icon" (click)="popupCreateModel(popup)">
        <i class="uil uil-file-plus-alt card_custom-icon"></i>
        <span class="card_custom-name">Add New</span>
      </a>
    </div>
  </div>
  <div>
    <ng-template #popup let-modal>

      <div class="modal-header">
        <span class="closepopup" (click)="modal.dismiss()">&times;</span>
        <h2 class="textpopup"> Create Airport</h2>
      </div>
      <div class="modal-body">
        <div style="margin-top:10px">
          <form class="form-line-active popuplabel">
            <div class="form-row ">
              <!--<div class="col-md-4 mb-3 ">
                <label for="validationServer01">ICOA Code</label>
                <input type="text" class="form-control " name="icaoCode" [(ngModel)]="newobj.icaoCode" id="validationServer01" placeholder="Please Enter ICOA CODE" required>

              </div>-->
              <div class="col-md-6 mb-3">
                <label for="validationServer02">IATA Code</label>
                <input type="text" class="form-control " name="IATACode" (keyup)="IataRegex()"
                  (blur)="toTitleCase(createobj.iATACode,$event)" [(ngModel)]="createobj.iATACode" id="iatacode1"
                  placeholder="Please Enter IATA CODE" required>
                <span class="tooltiptext" id="message1"></span>
                <span class="messageRequiredCreate" id="messageiata1"></span>
              </div>
              <div class="col-md-6 mb-3">
                <label for="validationServer01">Country</label>
                <ng-select class="airportselect countryrequired1" [items]="countryList" bindLabel="countryName"
                  bindValue="countryName" [searchable]="true" placeholder="Select Country"
                  [ngModelOptions]="{standalone: true}" [(ngModel)]="createobj.country">
                </ng-select>
                <span class="messageRequiredCreate" id="countryrequired1"></span>
                <!--<input type="text" class="form-control " name="country" [(ngModel)]="newobj.country" id="validationServer01" placeholder="Please Enter Country" required>-->

              </div>

            </div>
            <div class="form-row">
              <div class="col-md-6 mb-3">
                <label for="validationServer03">Airport Name</label>
                <input type="text" class="form-control" name="AirportName"
                  (blur)="toTitleCase(createobj.AirportName,$event)" [(ngModel)]="createobj.airportName"
                  id="nameairport1" placeholder="Please Enter Airport Name" required>
                <span class="messageRequiredCreate" id="messageAirport1"></span>
              </div>
              <div class="col-md-6 mb-3">
                <label for="validationServer04">City</label>
                <input type="text" class="form-control" name="City" (blur)="toTitleCase(createobj.city,$event)"
                  [(ngModel)]="createobj.city" id="city1" placeholder="Please Enter City" required>
                <span class="messageRequiredCreate" id="messageCity1"></span>
              </div>

            </div>

            <!-- *********New Section********* -->
            <div class="form-row">
              <div class="col-md-6 mb-3">
                <label for="validationServer05">Combine Airport From</label>
                <input type="text" class="form-control" name="combineAirportFrom1"
                  [(ngModel)]="createobj.combineAirportFrom" id="combineAirportFrom1" placeholder="Enter Value" autocomplete="off"
                  required>
                <span style="display: flex; justify-content: space-between; width: 100%;">
                  <span style="color: silver;">Enter Value Like <span
                      style="font-style: italic;">(ABC,DEF,GHI)</span></span>
                  <span class="text-danger" id="messagecombineAirportFrom1"></span>
                </span>
              </div>
              <div class="col-md-6 mb-3">
                <label for="validationServer05">Combine Airport To</label>
                <input type="text" class="form-control" name="combineAirportTo1"
                  [(ngModel)]="createobj.combineAirportTo" id="combineAirportTo1" placeholder="Enter Value" autocomplete="off" required>
                <span style="display: flex; justify-content: space-between; width: 100%;">
                  <span style="color: silver;">Enter Value Like <span
                      style="font-style: italic;">(ABC,DEF,GHI)</span></span>
                  <span class="text-danger" id="messagecombineAirportTo1"></span>
                </span>
              </div>


            </div>


            <!-- **********end********* -->

            <button class="btn submitButton" (click)="CreateAirport(sweet,bad)" type="submit">Create</button>
          </form>
        </div>
        <!--<button type="submit" (click)="SelectedRows()" class="profilesearchbutton">Submit</button>-->


      </div>
      <!--<div id="employeeInfo" *ngIf="grid.selectedRowKeys.length">
        <input [value]="grid.instance.getSelectedRowsData()[0].lastName" />
      </div>-->
    </ng-template>
  </div>



  <!--update airport details-->
  <div>
    <ng-template #update let-modal>

      <div class="modal-header">
        <span class="closepopup" (click)="modal.dismiss()">&times;</span>
        <h2 class="textpopup"> Update Airport</h2>
      </div>
      <div class="modal-body">
        <div style="margin-top:10px">
          <form class="form-line-active popuplabel">
            <div class="form-row">
              <!--<div class="col-md-4 mb-3">
                <label for="validationServer01">ICOA CODE</label>
                <input type="text" class="form-control " name="ICAOCode" [(ngModel)]="newobj.ICAOCode" id="validationServer01" placeholder="Please Enter ICOA CODE" required>

              </div>-->
              <div class="col-md-4 mb-3">
                <label for="validationServer02">IATA Code</label>
                <input type="text" class="form-control " name="IATACode" (keyup)="IataRegexUpdate()"
                  (blur)="toTitleCaseofUpdate(newobj.iATACode,$event)" [(ngModel)]="newobj.iATACode" id="iatacodew"
                  placeholder="Please Enter IATA CODE" required>
                <span class="tooltiptext" id="messagew"></span>
                <span class="messageRequired" id="messageiataw"></span>
              </div>
              <div class="col-md-4 mb-3">
                <label for="validationServer01">Country</label>
                <ng-select class="airportselect countryrequired" [items]="countryList" bindLabel="countryName"
                  bindValue="countryName" [searchable]="true" placeholder="Select Country"
                  [ngModelOptions]="{standalone: true}" [(ngModel)]="newobj.country">
                </ng-select>
                <span class="messageRequired" id="countryrequiredw"></span>
                <!--<input type="text" class="form-control " name="Country" [(ngModel)]="newobj.Country" id="validationServer01" placeholder="Please Enter Country" required>-->

              </div>
              <div class="col-md-4 mb-3">
                <label for="validationServer04">Status</label>
                <select class="form-control" name="Status" [(ngModel)]="newobj.status" id="status1">
                  <option class="optionsupdate">Blocked</option>
                  <option class="optionsupdate">Active</option>

                </select>
                <span class="messageRequired" id="messagestatusw"></span>
              </div>

            </div>
            <div class="form-row">
              <div class="col-md-8 mb-3">
                <label for="validationServer03">Airport Name</label>
                <input type="text" class="form-control" name="AirportName"
                  (blur)="toTitleCaseofUpdate(newobj.airportName,$event)" [(ngModel)]="newobj.airportName"
                  id="nameairportw" placeholder="Please Enter Airport Name" required>
                <span class="messageRequiredAirport" id="messageAirportw"></span>
              </div>
              <div class="col-md-4 mb-3">
                <label for="validationServer04">City</label>
                <input type="text" class="form-control" name="City" (blur)="toTitleCaseofUpdate(newobj.city,$event)"
                  [(ngModel)]="newobj.city" id="cityw" placeholder="Please Enter City" required>
                <span class="messageRequired" id="messageCityw"></span>
              </div>

              <!--<div class="col-md-4 mb-3">
    <label for="validationServer04">Status</label>
    <select class="form-control" name="Status" [(ngModel)]="newobj.Status" id="sel1">
      <option class="optionsupdate">Blocked</option>
      <option class="optionsupdate">Active</option>

    </select>

  </div>-->
            </div>

             <!-- *********New Section********* -->
            <div class="form-row">
              <div class="col-md-6 mb-3">
                <label for="validationServer05">Combine Airport From</label>
                <input type="text" class="form-control" name="combineAirportFrom2"
                  [(ngModel)]="newobj.combineAirportFrom" id="combineAirportFrom2" placeholder="Enter Value" autocomplete="off" required>
                <span style="display: flex; justify-content: space-between; width: 100%;">
                  <span style="color: silver;">Enter Value Like <span
                      style="font-style: italic;">(ABC,DEF,GHI)</span></span>
                  <span class="text-danger" id="messagecombineAirportFrom2"></span>
                </span>
              </div>
              <div class="col-md-6 mb-3">
                <label for="validationServer05">Combine Airport To</label>
                <input type="text" class="form-control" name="combineAirportTo2" [(ngModel)]="newobj.combineAirportTo"
                  id="combineAirportTo2" placeholder="Enter Value" autocomplete="off" required>
                <span style="display: flex; justify-content: space-between; width: 100%;">
                  <span style="color: silver;">Enter Value Like <span
                      style="font-style: italic;">(ABC,DEF,GHI)</span></span>
                  <span class="text-danger" id="messagecombineAirportTo2"></span>
                </span>
              </div>


            </div>

            <!-- **********end********* -->

            <button class="btn submitButton" (click)="UpdateAirport(sweet,bad)" type="submit">Update</button>
          </form>
        </div>
        <!--<button type="submit" (click)="SelectedRows()" class="profilesearchbutton">Submit</button>-->


      </div>
      <!--<div id="employeeInfo" *ngIf="grid.selectedRowKeys.length">
        <input [value]="grid.instance.getSelectedRowsData()[0].lastName" />
      </div>-->
    </ng-template>
  </div>





  <div class="row cms_tabel">
    <div id="grids">
      <dx-data-grid id="grid" [dataSource]="airportGetList" [showBorders]="true" [showRowLines]="true"
        (onContentReady)="contentReady($event)">


        <dxo-selection mode="single"></dxo-selection>
        <dxo-paging [pageSize]="100"></dxo-paging>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxi-column [visible]="false" dataType="number" dataField="id" alignment="center"></dxi-column>

        <!--<dxi-column dataField="icaoCode" caption="ICAO Code" dataType="string" alignment="center"></dxi-column>-->
        <dxi-column dataField="iataCode" caption="IATA Code" dataType="string" alignment="center"></dxi-column>
        <dxi-column dataField="airportName" caption="Airport Name" [width]="300" dataType="string"
          alignment="center"></dxi-column>
        <dxi-column dataField="city" caption="City" dataType="string" alignment="center"></dxi-column>
        <dxi-column dataField="country" caption="Country" dataType="string" alignment="center"></dxi-column>
        <dxi-column dataField="status" caption="Status" dataType="string" alignment="center"></dxi-column>




        <dxi-column caption="Action" [allowSorting]="false" alignment="center"
          cellTemplate="actionCellTemplate"></dxi-column>


        <div *dxTemplate="let data of 'actionCellTemplate'">
          <div class="card_buttons">
            <a class="card_button-edit" (click)="updatepopup(data.data,update)">
              <i class="uil uil-edit card_button-icon"></i>
            </a>
            <a class="cardBlock" (click)="DeleteAirport(data.data.id,sweet,bad)">
              <i class="">

                <img class="imageBlock" src="assets/img/remove.png" />
              </i>
            </a>
          </div>
          <!--<a class="profilesearchbutton" style="margin-left:10px" (click)="Select_Profiledata(data.data)"><i class="fas fa-check-square"></i> Select</a>-->
        </div>
      </dx-data-grid>



    </div>

  </div>
</div>
